'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _tracking = require('@spp/tracking');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Link = require('../Link');

var _Link2 = _interopRequireDefault(_Link);

var _svg = require('../svg');

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    SITEMAP_ITEM: 'MainMenu_SitemapItem'
};

var siteMapItemClick = function siteMapItemClick(engagement, url, name) {
    return function (event) {
        event.preventDefault();

        _tracking.util.actionThenRelocateWithTimeout(engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.SITEMAP_ITEM,
            meta: { name: name, event: event }
        }), url);
    };
};

var SiteMap = function SiteMap(_ref) {
    var parentElement = _ref.parentElement,
        chevronSvg = _ref.chevronSvg,
        theme = _ref.theme,
        onSitemapClose = _ref.onSitemapClose,
        engagement = _ref.engagement,
        isSitemapOpen = _ref.isSitemapOpen;

    var sitemapLinkClass = isSitemapOpen ? theme['sitemapLink-Open'] : theme.sitemapLink;
    var sitemapTitleClass = isSitemapOpen ? theme['title-Open'] : theme.title;
    var renderSiteMapElements = function renderSiteMapElements() {
        return parentElement.siteMap.map(function (item) {
            return _react2.default.createElement(
                'li',
                { key: item[0].name, className: theme.listGroup },
                _react2.default.createElement(
                    'ul',
                    { className: theme.sublist },
                    item.map(function (innerItem) {
                        return _react2.default.createElement(
                            'li',
                            { key: innerItem.name, className: theme.sublistItem },
                            _react2.default.createElement(
                                _Link2.default,
                                {
                                    link: innerItem.url,
                                    className: sitemapLinkClass,
                                    onClick: siteMapItemClick(engagement, innerItem.url, innerItem.name),
                                    enableSinglePage: true
                                },
                                innerItem.name
                            )
                        );
                    })
                )
            );
        });
    };

    if (!parentElement.siteMap || parentElement.siteMap.length === 0) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            { className: theme.divider },
            _react2.default.createElement(
                'button',
                { className: sitemapTitleClass, onClick: onSitemapClose },
                _react2.default.createElement(_svg.ChevronLeftSvg, {
                    icon: chevronSvg,
                    title: chevronSvg.title
                }),
                parentElement.name
            )
        ),
        _react2.default.createElement(
            'ul',
            { className: theme.sitemapList },
            renderSiteMapElements()
        )
    );
};

if (process.env.NODE_ENV !== 'production') {
    SiteMap.propTypes = {
        engagement: _propTypes2.default.func,
        parentElement: _propTypes2.default.shape({
            name: _propTypes2.default.string.isRequired,
            siteMap: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape(_props.sectionProps)))
        }).isRequired,
        chevronSvg: _propTypes2.default.shape(_props.svgProps).isRequired,
        theme: _propTypes2.default.shape({
            divider: _propTypes2.default.string,
            listGroup: _propTypes2.default.string,
            sitemapList: _propTypes2.default.string,
            sublist: _propTypes2.default.string,
            sublistItem: _propTypes2.default.string,
            title: _propTypes2.default.string
        }),
        onSitemapClose: _propTypes2.default.func,
        isSitemapOpen: _propTypes2.default.bool.isRequired
    };
}

SiteMap.defaultProps = {
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    onSitemapClose: undefined,
    theme: {}
};

exports.default = SiteMap;
//# sourceMappingURL=SiteMap.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/SiteMap/SiteMap.js
 ** module id = 616
 ** module chunks = 1
 **/